
export const appAdminRoutes: any[] = [
    {
        index: true,
        path: "/admin/dashboard",
        section: "dashboard",
        sidebarProps: {
            displayText: "Dashboard",
            icon: 'dashboard',
        },
    },
    {
        index: true,
        path: "/admin/quotes",
        section: "quotes",
        sidebarProps: {
            displayText: "Quotes",
           icon: "article",
        },
    },
]